import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OpeningRoutingModule } from './opening-routing.module';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { MatMenuModule } from '@angular/material/menu';
import { NouisliderModule } from 'ng2-nouislider';
import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
    ListComponent,
    AddComponent,
  ],
  imports: [
    CommonModule,
    OpeningRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxDatatableModule,
    NgxSpinnerModule,
    PipeModule,
    MatMenuModule,
    NouisliderModule,
    NgxMaskModule.forRoot(),
  ]
})
export class OpeningModule { }
